import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getRum } from "../../aws-app-monitor/rum";

export const ClickRumTracker: React.FC = () => {
  /*
    CloudWatch RUM – Click Tracking
    Tracks user clicks across pages to analyze user interactions in CloudWatch dashboards.
  */

  const location = useLocation();

  useEffect(() => {
    const rum = getRum();
    if (!rum) return;

    const handleClick = () => {
      // Normalize dynamic canvas routes (UUID-based) to a single "/canvas" route
      let route = location.pathname;
      if (route.startsWith("/canvas")) {
        route = "/canvas";
      }

      rum.recordEvent("ui_click", {
        route: route,
      });
    };

    document.addEventListener("click", handleClick, true);

    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, [location.pathname]);

  return null;
};
